import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AttachmentService } from '../../services/attachment.service';

export interface FileViewerData {
  blobName: string;
  originalFileName: string;
  fileType: string;
  sasUrl?: string;
  expiresOn?: string;
}

@Component({
  selector: 'app-file-viewer',
  templateUrl: './file-viewer.component.html',
  styleUrl: './file-viewer.component.scss'
})
export class FileViewerComponent implements OnInit {
  fileUrl = '';
  loading = true;
  error = false;
  imageZoom = 1;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FileViewerData,
    public dialogRef: MatDialogRef<FileViewerComponent>,
    private attachmentService: AttachmentService
  ) {}

  ngOnInit(): void {
    if (this.data.sasUrl) {
      this.fileUrl = this.data.sasUrl;
      this.loading = false;
    } else {
      this.attachmentService
        .getAttachmentReadUrl(this.data.blobName, this.data.expiresOn || '', '')
        ?.subscribe({
          next: (result) => {
            this.fileUrl = result.readSasUri;
            this.loading = false;
          },
          error: () => {
            this.error = true;
            this.loading = false;
          }
        });
    }
  }

  get isPdf(): boolean {
    return (
      this.data.fileType === 'application/pdf' ||
      (this.data.originalFileName || '').toLowerCase().endsWith('.pdf')
    );
  }

  get isImage(): boolean {
    return (
      (this.data.fileType || '').startsWith('image/') ||
      /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(this.data.originalFileName || '')
    );
  }

  get isVideo(): boolean {
    return (this.data.fileType || '').startsWith('video/');
  }

  get isAudio(): boolean {
    return (this.data.fileType || '').startsWith('audio/');
  }

  get isUnsupported(): boolean {
    return !this.isPdf && !this.isImage && !this.isVideo && !this.isAudio;
  }

  zoomIn(): void  { this.imageZoom = Math.min(+(this.imageZoom + 0.25).toFixed(2), 5); }
  zoomOut(): void { this.imageZoom = Math.max(+(this.imageZoom - 0.25).toFixed(2), 0.25); }
  resetZoom(): void { this.imageZoom = 1; }
}
